import React from 'react'
import './Hmclient.css'
import Marquee from 'react-fast-marquee'
import qticket from '../../../../assets/img/qtickets.webp'
import qatarday from '../../../../assets/img/qatarday.webp'
import citycenter from '../../../../assets/img/city_center.webp'
import monoprix from '../../../../assets/img/monoprix.webp'
import tourism from '../../../../assets/img/qatar_tourism.webp'
import culture from '../../../../assets/img/qatar_culture.webp'
import bpo from '../../../../assets/img/bpo.webp'
import nandos from '../../../../assets/img/nandos.webp'
import karak from '../../../../assets/img/karak.webp'
import play from '../../../../assets/img/360play.webp'
import diet from '../../../../assets/img/diet_delight.webp'
import kc from '../../../../assets/img/Katara_cinema.webp'
import oq from '../../../../assets/img/olymic_qatar.webp'
import na from '../../../../assets/img/naseem_alrabeeh.webp'
import mcp from '../../../../assets/img/mcp.webp'
import mc from '../../../../assets/img/mannai_corporation.webp'
import hsb from '../../../../assets/img/hilton_salwa_beach.webp'
import qa from '../../../../assets/img/qatar_airways.webp'
import qr from '../../../../assets/img/qatar_rail.webp'
import qfa from '../../../../assets/img/qfa.webp'

function Hmclient() {

 const margueeleft = [
    {
        img: qticket
    },
    {
        img: qatarday
    },
    {
        img: citycenter
    },
    {
        img: monoprix
    },
    {
        img: tourism
    },
    {
        img: culture
    },
    {
        img: bpo
    },
    {
        img: nandos
    },
    {
        img: karak
    },
    {
        img: play
    },
    {
        img: diet
    },
    {
        img: kc
    },
    {
        img: oq
    },
    {
        img: na
    },
    {
        img: mcp
    },
    {
        img: mc
    },
    {
        img: hsb
    },
    {
        img: qa
    },
    {
        img: qr
    },
    {
        img: qfa
    }

 ]   

 const firstHalf = margueeleft.slice(0, 10);  // first 5 images
  const secondHalf = margueeleft.slice(10);    // rest of the images

  return (
    <section className='hmclient-sec'>
        <div className='container'>
          <div className='mn-head'> 
            <h5>Our Clients</h5>
            <h3>Growing together always</h3>
          </div> 
        </div>
       <Marquee pauseOnHover>
         {
            firstHalf.map((Hmclient, index)=>(
                <div className='hmclient-item' key={index}><img src={Hmclient.img} alt='' loading="lazy"/></div>
            ))
         }
       </Marquee>
       <Marquee pauseOnHover direction='right'>
         {
            secondHalf.map((Hmclient, index)=>(
                <div className='hmclient-item' key={index}><img src={Hmclient.img} alt='' loading="lazy"/></div>
            ))
         }
       </Marquee>
    </section>
  )
}

export default Hmclient
